import { arrayOf } from 'prop-types';
import React from 'react';

import { BrandLinks } from '../../brands/Link';
import Titled from '../../layout/Titled';
import { brandShape } from '../../prop-types';
import api from '../../REST/api';
import withResolved from '../../REST/with-resolved';

function PeerBrands({ brands }) {
  return (
    <Titled title="Peer brands" size="tn">
      <BrandLinks models={brands} verbose />
    </Titled>
  );
}

PeerBrands.propTypes = {
  brands: arrayOf(brandShape.isRequired).isRequired,
};

export default withResolved({
  query: async brandCode => {
    const { peerBrands: peerBrandCodes } = await api.getPeerBrands({
      search: { brandCode },
    });
    if (peerBrandCodes && peerBrandCodes.length) {
      return api.getBrands({ search: { code: peerBrandCodes } });
    }
    throw new Error('No Peer Brands have been found for these criteria.');
  },
  deriveQueryArgs: props => props.brandCode,
  as: 'brands',
})(PeerBrands);
